export default "__VITE_ASSET__CgZTXg3Z__"